/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export enum RedEnvelopeTypeEnum {
  普通红包 = 0,
  世界红包 = 1,
  红包卡 = 2,
}

export const get_union_recommend_list = createAsyncThunk(
  'RedEnvelope/get_union_recommend_list',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/union/get_union_recommend_list',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const get_red_packet_record = createAsyncThunk(
  'RedEnvelope/get_red_packet_record',
  async (params: any, store: any) => {
    // return {
    //   send_list: [
    //     {
    //       type: 0,
    //       msg: 'Get lucky bag from hiya123445667890',
    //       time: '2025-02-04  12:00:00',
    //       coins: 1000,
    //       num: 100,
    //       receive_num: 88,
    //     },
    //     {
    //       type: 1,
    //       msg: 'Get lucky bag from hiya123445667890',
    //       time: '2025-02-04  12:00:00',
    //       coins: 1000,
    //       num: 100,
    //       receive_num: 88,
    //     },
    //     {
    //       type: 2,
    //       msg: 'Get lucky bag from hiya123445667890',
    //       time: '2025-02-04  12:00:00',
    //       coins: 1000,
    //       num: 100,
    //       receive_num: 88,
    //     },
    //   ],
    //   receive_list: [
    //     {
    //       type: 0,
    //       msg: 'Get lucky bag from hiya123445667890',
    //       time: '2025-02-04  12:00:00',
    //       coins: 1000,
    //       num: 100,
    //       receive_num: 88,
    //     },
    //     {
    //       type: 1,
    //       msg: 'Get lucky bag from hiya123445667890',
    //       time: '2025-02-04  12:00:00',
    //       coins: 1000,
    //       num: 100,
    //       receive_num: 88,
    //     },
    //     {
    //       type: 2,
    //       msg: 'Get lucky bag from hiya123445667890',
    //       time: '2025-02-04  12:00:00',
    //       coins: 1000,
    //       num: 100,
    //       receive_num: 88,
    //     },
    //   ],
    // }
    const resp = await http.post(
      '/live/room/get_red_packet_record',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  detail: any
  record: any
}

const initialState: InitialStateType = {
  detail: {},
  record: {
    send_list: [],
    receive_list: [],
  },
}

export const RedEnvelopeSlice = createSlice({
  name: 'RedEnvelope',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_union_recommend_list.fulfilled, (state, action) => {
      Object.assign(state, {
        detail: action.payload,
      })
    })
    builder.addCase(get_red_packet_record.fulfilled, (state, action) => {
      Object.assign(state, {
        record: action.payload,
      })
    })
  },
})
export default RedEnvelopeSlice.reducer
export const RedEnvelopeActions = RedEnvelopeSlice.actions

export const useRedEnvelopeState = () => {
  const data = useSelector((state) => {
    return state.Animal_Rat
  })
  return data
}
